import apiClient from "./apiClient";
import {removeNullFields} from "@/utils/utils";

const BASE_URL = process.env.VUE_APP_BASE_URL as string;

const universityService = {
    async getAll(params: any): Promise<any> {
        try {
            const paramsCopy = structuredClone(params);
            paramsCopy.filter = removeNullFields(paramsCopy.filter);
            const response = await apiClient.post<any>(
                `${BASE_URL}/api/v1/university/all`,
                paramsCopy
            )
            return response.data;
        } catch (error) {
            console.error("Error fetching university list:", error);
            throw error;
        }
    },

    async findById(universityId: number): Promise<any> {
        try {
            const response = await apiClient.get<any>(`${BASE_URL}/api/v1/university/findById/${universityId}`);
            return response.data;
        } catch (error) {
            console.error("Error findById university", error);
            throw error;
        }
    },

    async save(university: any): Promise<any> {
        try {
            const response = await apiClient.post<any>(
                `${BASE_URL}/api/v1/university/save`,
                university
            );
            return response.data;
        } catch (error) {
            console.error("Error save university", error);
            throw error;
        }
    },

    async deleteById(universityId: number): Promise<any> {
        try {
            const response = await apiClient.delete<any>(`${BASE_URL}/api/v1/university/deleteById/${universityId}`);
            return response.data;
        } catch (error) {
            console.error("Error deleteById university", error);
            throw error;
        }
    }
}

export default universityService;